import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";

export default function Acoes({
  acoes,
  isConsultaNova,
}: {
  acoes: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const hasAcoes = acoes && acoes.length > 0;
  const resumos = hasAcoes && acoes[0]?.resumos ? acoes[0].resumos : [];

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: hasAcoes ? '#FEF2F2' : '#F0FDF4',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className={hasAcoes ? 'pi pi-exclamation-triangle' : 'pi pi-check-circle'}
              style={{ color: hasAcoes ? '#DC2626' : '#16A34A', fontSize: '18px' }}
            />
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('acoesQuod')}
            </h3>
            {hasAcoes && (
              <span style={{ fontSize: 'small', color: '#6B7280' }}>
                {acoes.length} ação/ações encontrada{acoes.length !== 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>

        {!hasAcoes ? (
          <NadaConsta />
        ) : (
          <>
            {/* Summary cards */}
            {resumos.length > 0 && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                  gap: '12px',
                  marginBottom: '20px',
                }}
              >
                {resumos.map((item: any, idx: number) => (
                  <div
                    key={idx}
                    style={{
                      backgroundColor: '#1E3A8A',
                      borderRadius: '12px',
                      padding: '14px 16px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span style={{ color: '#93C5FD', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase' }}>
                        {item.label}
                      </span>
                      <span style={{ color: '#FFFFFF', fontWeight: 800, fontSize: '1.1rem' }}>{item.value}</span>
                    </div>
                    <span
                      style={{
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i className={item.icon} style={{ color: '#FFFFFF', fontSize: '14px' }} />
                    </span>
                  </div>
                ))}
              </div>
            )}

            {/* Table */}
            <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
                <thead>
                  <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                    {[t('numero'), t('autor'), t('comarca'), t('forum'), t('vara'), t('cidadeUF'), t('valor'), t('dataDistribuicao'), t('tipo'), t('origem')].map(h => (
                      <th
                        key={h}
                        style={{
                          padding: '10px 14px',
                          fontWeight: 700,
                          color: '#6B7280',
                          fontSize: '0.7rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.04em',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {acoes.map((acao: any, idx: number) => (
                    <tr
                      key={idx}
                      style={{ borderBottom: idx < acoes.length - 1 ? '1px solid #F3F4F6' : 'none' }}
                      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#FEF2F2')}
                      onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                    >
                      <td style={{ padding: '10px 14px', color: '#1D4ED8', fontWeight: 600 }}>{acao.numero}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.autor}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.comarca}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.forum}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.vara}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{acao.cidadeUF}</td>
                      <td style={{ padding: '10px 14px', fontWeight: 700, color: '#DC2626', whiteSpace: 'nowrap' }}>{acao.valor || '—'}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{acao.dataDistribuicao}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <span style={{ backgroundColor: '#F3F4F6', color: '#374151', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '4px', whiteSpace: 'nowrap' }}>
                          {acao.tipo}
                        </span>
                      </td>
                      <td style={{ padding: '10px 14px' }}>
                        <span
                          style={{
                            backgroundColor: acao.origem === 'FEDERAL' ? '#EFF6FF' : '#F0FDF4',
                            color: acao.origem === 'FEDERAL' ? '#1D4ED8' : '#15803D',
                            fontSize: '0.7rem',
                            fontWeight: 700,
                            padding: '2px 8px',
                            borderRadius: '4px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {acao.origem}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  }

  // Legacy layout
  return (
    <Panel header={t('acoesQuod')}>
      {acoes.length === 0 ? (
        <NadaConsta />
      ) : (
        <div>
          <div className="flex-consulta flex-wrap gap-3">
            {acoes[0].resumos.map((item: any, index: number) => (
              <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                <div className="flex-consulta justify-content-between gap-5">
                  <div className="flex-consulta flex-column gap-1">
                    <span style={{ color: 'white' }} className="text-sm">{item.label}</span>
                    <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                  </div>
                  <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                    <i className={item.icon} />
                  </span>
                </div>
              </Card>
            ))}
          </div>
          <br></br>
          <DataTable size="small" value={acoes} tableStyle={{ minWidth: '50rem' }}>
            <Column field="numero" header={t('numero')}></Column>
            <Column field="autor" header={t('autor')}></Column>
            <Column field="comarca" header={t('comarca')}></Column>
            <Column field="forum" header={t('forum')}></Column>
            <Column field="vara" header={t('vara')}></Column>
            <Column field="cidadeUF" header={t('cidadeUF')}></Column>
            <Column field="valor" header={t('valor')}></Column>
            <Column field="dataDistribuicao" header={t('dataDistribuicao')}></Column>
            <Column field="tipo" header={t('tipo')}></Column>
            <Column field="origem" header={t('origem')}></Column>
          </DataTable>
        </div>
      )}
    </Panel>
  );
}